import { Flat } from "./HardMatch";

export interface RealEstatePlatform {
    key: string;
    title: string;
    icon: string;
    getApplyUrl?: (flat: Flat) => string;
}

const realEstatePlatforms: RealEstatePlatform[] = [
    { 
        key: 'wohnverdient', 
        title: 'Wohnverdient', 
        icon: 'wohnverdient-icon.svg',
    },
    { 
        key: 'ebaykleinanzeigen', 
        title: 'Kleinanzeigen', 
        icon: 'ebay-icon.svg'
    },
    { 
        key: 'wggesucht', 
        title: 'WG-Gesucht', 
        icon: 'wggesucht-icon.svg',
        getApplyUrl: (flat) => {
            const url = new URL(flat.link);
            // Add /nachricht-senden at the beginning of the path
            url.pathname = `/nachricht-senden${url.pathname}`;
            return url.toString();
        }
    },
    { 
        key: 'immowelt', 
        title: 'Immowelt', 
        icon: 'immowelt-icon.svg',
        getApplyUrl: (flat) => `${flat.link}?modal=CONTACT_FORM`
    },
    { 
        key: 'immoscout', 
        title: 'ImmoScout24', 
        icon: 'immoscout-icon.svg',
        getApplyUrl: (flat) => `${flat.link}?modal=CONTACT_FORM`
    },
];

export function getRealEstatePlatformMetadata(siteKey: string | null): RealEstatePlatform {
    const fallbackPlatform = { key: 'unknown', title: 'Others', icon: 'unknown-icon.svg' };
    if (!siteKey)
        return fallbackPlatform;

    const platform = realEstatePlatforms.find(platform => platform.key === siteKey);

    return platform ?? fallbackPlatform;
}